import { BaseApp } from "../core/app";
import IndexView from "../core/views/index/index";
import { ValtasiirtoBaseApp } from "./valtaSiirtoBaseApp";
import OrderListView from "../views/orderList/index";
import OrderItemListView from "../views/orderItemList/index";
import Router from "../core/router/index";
import TestView from "../views/test/index";
import TestStep01View from "../views/testChain/step01/index";
import TestStep02View from "../views/testChain/step02/index";
import TestStep03View from "../views/testChain/step03/index";

export class ForkliftApplication extends ValtasiirtoBaseApp
{
    public configureRouter(router: Router)
    {
        super.configureRouter(router);
        
        router.add(/^(|\/|\/orders|\/orders\/)$/, OrderListView);
        router.add(/^(\/order-items|\/order-items\/)$/, OrderItemListView);
        router.add('/test/', TestView);
        router.add('/test', TestView, {gender: 'other'});
        router.add(/\/test-chain/, [TestStep01View, TestStep02View, TestStep03View], {gender: 'other'});
    }
}

export const app = new ForkliftApplication();
